import { getAxiosAPIInstance } from "./config";
import {
  LOGIN_LOCAL_LOADING,
  LOGIN_LOCAL_SUCCESS,
  LOGIN_LOCAL_FAIL,
  SIGNUP_LOCAL_LOADING,
  SIGNUP_LOCAL_SUCCESS,
  SIGNUP_LOCAL_FAIL,
  ME_LOADING,
  ME_SUCCESS,
  ME_FAIL,
  LOGOUT_SUCCESS,
} from "../reducers/types";

const client = getAxiosAPIInstance();

export const loginUserLocal = async (credentials, dispatch, navigate) => {
  dispatch({ type: LOGIN_LOCAL_LOADING });

  try {
    const { data } = await client.post("/authenticate/login", credentials);
    dispatch({
      type: LOGIN_LOCAL_SUCCESS,
      payload: { token: data.token, me: data.user },
    });
    navigate("/dashboard");
  } catch (err) {
    const errorMessage =
      err.response?.data?.error || err.response?.data?.message || err.message || "Login failed";

    dispatch({
      type: LOGIN_LOCAL_FAIL,
      payload: { error: errorMessage },
    });
  }
};

export const signupUserLocal = async (credentials, dispatch, navigate) => {
  dispatch({ type: SIGNUP_LOCAL_LOADING });

  try {
    const { data } = await client.post("/authenticate/signup", credentials);
    dispatch({
      type: SIGNUP_LOCAL_SUCCESS,
      payload: { token: data.token, me: data.user },
    });
    navigate("/dashboard");
  } catch (err) {
    // Normalize error to string
    const errorMessage =
      err.response?.data?.error || err.response?.data?.message || err.message || "Signup failed";

    dispatch({
      type: SIGNUP_LOCAL_FAIL,
      payload: { error: errorMessage },
    });
  }
};

export const loadMe = async (dispatch) => {
  dispatch({ type: ME_LOADING });

  try {
    const { data } = await client.get("/authenticate/me");

    dispatch({
      type: ME_SUCCESS,
      payload: { me: data },
    });
  } catch (err) {
    dispatch({
      type: ME_FAIL,
      payload: { error: err },
    });
  }
};

export const logout = async (dispatch, navigate) => {
  dispatch({
    type: LOGOUT_SUCCESS,
  });
  navigate("/login");
};

export const requestPasswordReset = async (email) => {
  try {
    const { data } = await client.post("/authenticate/reset-password/request", {
      email,
    });
    return data;
  } catch (err) {
    throw err;
  }
};

export const validateResetToken = async (token, uid) => {
  try {
    const { data } = await client.get("/authenticate/reset-password/validate", {
      params: {
        token,
        uid
      },
    });

    return data;
  } catch (err) {
    throw err;
  }
};

export const confirmPasswordReset = async ({newPassword, uid, token}) => {
  try {
    const { data } = await client.post("/authenticate/reset-password/confirm", {
      newPassword,
      uid,
      token
    });
    return data;
  } catch (err) {
    throw err;
  }
};
